import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getIcon } from 'utils/icons.utils';

interface Props {
  text: string;
  path: string;
  iconName?: string;
}

export const DashboardTile = ({ text, path, iconName }: Props) => {
  const navigate = useNavigate();
  const handleClick = useCallback(() => {
    navigate(path);
  }, [navigate, path]);

  return (
    <div className='tile' onClick={handleClick} aria-hidden='true'>
      {iconName && (
        <div className='tile__icon'>
          {getIcon(iconName, {
            fontSize: 'large',
            sx: { opacity: 1, fontSize: '3rem' },
          })}
        </div>
      )}
      {text}
    </div>
  );
};
